import {Entity} from "./Entity";

export class Port extends Entity {
    adresse?: string;

}